var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 58,
    viewBox: "0 0 133 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6304 14.8398L65.9328 9.48737L90.749 14.8398L65.9328 21.8107L40.6304 14.8398Z",
    fill: "#DDE3EB",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6304 14.8359L65.9328 9.48347V21.8067L40.6304 14.8359Z",
    fill: "#CDD5DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6304 14.8359L65.9328 9.48347L90.749 14.8359L65.9328 21.8067L40.6304 14.8359Z",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1436 15.3281L66.4193 21.9457V48.4161L40.1436 39.9078V15.3281Z",
    fill: "#F7F8F9",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7485 15.3281L66.4191 21.9457V48.4161L90.7485 39.9078V15.3281Z",
    fill: "#F7F8F9",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3552 14.7773L66.1616 21.8863L71.9681 30.7773L96.1616 21.839L90.3552 14.7773Z",
    fill: "#F7F8F9",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6616 14.7773L65.4461 21.9451L59.607 31.1347L34.791 21.9453L40.6616 14.7773Z",
    fill: "#F7F8F9",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89908 37.8778C7.83162 36.0804 12.1567 32.8173 17.3234 31.8869L20.7641 31.2673L34.9297 37.737L28.0549 38.975C25.1432 39.4993 22.4189 40.7744 20.151 42.6742L17.4314 44.9524C17.4314 44.9524 1.20442 38.4954 2.89908 37.8778Z",
    fill: "#F7F8F9",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9795 34.9238L24.0794 37.3524",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5913 36.1562L20.6912 38.5848",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9668 38.3613L17.0667 40.7899",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.649 42.872C113.216 42.7702 112.768 42.4545 112.326 42.0135C109.307 38.9962 106.702 35.4197 102.8 33.6906L98.3548 31.7215L84.075 35.9985L90.2098 39.4067C92.1025 40.4582 93.7769 41.8616 95.143 43.5415L98.3549 47.491C98.3549 47.491 115.837 43.3867 113.649 42.872Z",
    fill: "#F7F8F9",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3872 36.5273L91.5752 38.082",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.575 39L96.0752 40.5",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.575 43L99.5752 44.082",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.575 27.397C105.575 27.397 110.035 27.683 112.16 31.0719",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5753 29.6928C98.5753 29.6928 100.075 29.2949 101.075 30.7952",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0589 25.2719C23.0589 25.2719 25.0096 24.3088 27.5204 24.1749",
    stroke: "#ACB1BB",
    strokeWidth: 0.777778,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFailIcon);
export default __webpack_public_path__ + "static/media/upload-fail-icon.6031e994958e8dfe292adf2ca2a2481a.svg";
export { ForwardRef as ReactComponent };